import createIcon from '../../createIcon';

/**
 * @component @name Drafts
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuOTkgOS41QzIxLjk5IDguNzggMjEuNjIgOC4xNSAyMS4wNSA3LjhMMTIgMi41TDIuOTUgNy44QzIuMzggOC4xNSAyIDguNzggMiA5LjVWMTkuNUMyIDIwLjYgMi45IDIxLjUgNCAyMS41SDIwQzIxLjEgMjEuNSAyMiAyMC42IDIyIDE5LjVMMjEuOTkgOS41Wk0xMiAxNC41TDMuNzQgOS4zNEwxMiA0LjVMMjAuMjYgOS4zNEwxMiAxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Drafts = createIcon('Drafts', [
  [
    'path',
    {
      d: 'M21.99 9.5C21.99 8.78 21.62 8.15 21.05 7.8L12 2.5L2.95 7.8C2.38 8.15 2 8.78 2 9.5V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5L21.99 9.5ZM12 14.5L3.74 9.34L12 4.5L20.26 9.34L12 14.5Z',
      key: 'ejf1my',
    },
  ],
]);

export default Drafts;
